<template>
  <div class="card" id="cardObservacoes">
    <b-card-header
      :header="header"
      header-text-variant="white"
      header-tag="header"
      style="background-color:rgb(55, 71, 79)"
    ></b-card-header>
    <b-card class="table-responsive-sm" v-if="this.clientesObs.duplicatas">
      <b-card-text class="table" id="tableCliObs" v-if="this.clientesObs.duplicatas.length > 0">
        <b-table bordered striped :items="clientesObs.duplicatas" :fields="fields" fixed />
      </b-card-text>
      <span v-else>Não há itens para exibir nesta sessão</span>
    </b-card>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      title: '',
      header: '',
      pCardPedidosEmObservacaoValues: {duplicatas: []}
    },
    computed: {
      ...mapState({
        cor: state => {
          const { cor } = state.cor
          return {
            'background-color': cor
          }
        }
      })
    },
    watch: {
      pCardPedidosEmObservacaoValues: function (newVal, oldVal) { // watch it
        this.dashboard = newVal
      }
    },
    data () {
      return {
        clientesObs: [],
        fields: [
          {
            key: 'fantasia',
            label: 'Cliente',
            sortable: true,
            formatter: this.toCapitalize,
            class: 'colCLiente txtLeft'
          },
          {
            key: 'vencimento',
            label: 'Vencto.',
            sortable: true,
            class: 'p-0'
          },
          {
            key: 'diasAtraso',
            label: 'Dias Atr.',
            sortable: true
          },
          {
            key: 'valor',
            label: 'Valor R$',
            sortable: true,
            formatter: this.formatterValue,
            class: 'txtRight'
          }
          // ,
          // {
          //   key: 'codCliente',
          //   label: 'Cód. Cliente',
          //   sortable: true
          // }
        ]
      }
    },
    mounted () {
      this.clientesObs = this.pCardPedidosEmObservacaoValues
    },
    methods: {
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      formatterValue: valor => {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    }
  }
</script>
<style scoped>
  .table {
    overflow-y: scroll;
    position: relative;
    min-height: 82px;
    max-height: 210px;
    font-size: 14px;
  }
</style>




// WEBPACK FOOTER //
// src/components/items/CardPedidosObservacaoVue.vue